/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { County } from "./county";
import { LicenseClass } from "./license-class";

export class Retailer {
    crNum: number;
    crNumOld: number;
    entityName: string = "";
    tradeAsName: string = "";
    streetAddr1: string = "";
    streetAddr2: string = "";
    city: string = "";
    county_fk: number;
    county: County;
    state: string = "";
    zipCode: string = "";
    phone: string;
    licenseClass_fk: number;
    licenseClass: LicenseClass;
    offPremise: string;
    status: string = "";
    statusDate: Date;
    updatedBy: string;
    lastUpdate: Date;
    licensee1: string;
    licensee2: string;
    licensee3: string;
    comments: string;
    history: string;
}
